/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { INodeProps } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { OptionHTMLAttributes } from 'react';

export interface IBusinessSignUpSelectProps {
    id?: string;
    value?: string;
    optionList?: OptionHTMLAttributes<any>[];
    className: string;
    isRequired: boolean;
    fieldReference?: React.RefObject<HTMLSelectElement>;
    onChange?(event: React.ChangeEvent<HTMLSelectElement>): void;
}

export interface IBusinessSignUpSelect {
    key: string;
    AddressItem: INodeProps;
    label: React.ReactNode;
    alert: React.ReactNode;
    input: React.ReactNode;
}

export const SignUpSelect: React.FC<IBusinessSignUpSelectProps> = ({
    id,
    value,
    optionList,
    className,
    isRequired,
    onChange,
    fieldReference
}) => {
    return (
        <select
            id={id}
            className={`${className}-input ${className}-${id}`}
            // aria-required={isRequired}
            ref={fieldReference}
            onChange={onChange}
        >
            {optionList &&
                optionList.map((item, i) => (
                    <option value={item.value} key={i} selected={item.selected}>
                        {item.label}
                    </option>
                ))}
        </select>
    );
};

export default SignUpSelect;
